<template>
  <div class="d-flex">
    <svg
      :width="width"
      height="8"
      class="mt-2"
    >
      <Completion
        :x="x"
        :y="y"
        :r="r"
        :width="width"
        :height="height"
        :completion="completion"
      />
    </svg>
    <div
      :class="CompletionColor"
      class="ml-2"
    >
      {{ $n(Math.round(completion) / 100, 'percent') }}
    </div>
  </div>
</template>

<script>
  import Completion from '@/components/common/RelationCard/RelationCompletion'

  export default {
    components: {
      Completion,
    },
    props: {
      completion: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        x: 0,
        y: 0,
        r: 5,
        width: 100,
        height: 8,
      }
    },
    computed: {
      CompletionColor() {
        if (this.completion >= 100) {
          return 'CompletionCell--success'
        }
        if (this.completion >= 40) {
          return 'CompletionCell--warning'
        }

        return 'CompletionCell--error'
      },
    },
  }
</script>

<style scoped lang="scss">
$success: $color-00d367;
$warning: $color_f6a60f;
$error: $color_ea3b38;

.CompletionCell {
  &--success {
    color: $success;
  }
  &--warning {
    color: $warning;
  }
  &--error {
    color: $error;
  }
}
</style>
